"use client";

import { Languages, MessageSquare, FileText, ClipboardList, BadgeCheck, Users, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Japanesesupportoverview() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const capabilities = [{
    number: "01",
    title: "Business & Corporate",
    description: "Comprehensive counsel for formation, ownership planning, and the strategic purchase or sale of business entities.",
    Icon: BadgeCheck
  }, {
    number: "02",
    title: "Real Estate Law",
    description: "Sophisticated guidance for residential and commercial transactions, ownership transfers, and property rights.",
    Icon: MessageSquare
  }, {
    number: "03",
    title: "Estate Planning",
    description: "Drafting precise wills, trusts, powers of attorney, and healthcare documents to protect your family's legacy.",
    Icon: FileText
  }, {
    number: "04",
    title: "Probate Guidance",
    description: "Professional support for personal representatives navigating the complexities of Florida probate administration.",
    Icon: ClipboardList
  }, {
    number: "05",
    title: "Attorney’s Fee Hearings",
    description: "Providing specialized Expert Witness testimony in attorney’s fee hearings based on decades of legal experience.",
    Icon: Languages
  }, {
    number: "06",
    title: "Business Litigation",
    description: "Selective representation in commercial disputes, focused on achieving calm and intelligent resolutions.",
    Icon: Users
  }];
  return <div className="bg-background">
      
    </div>;
}